/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentStateEnum = {
    PrevedenoNaAspeesticon: 'prevedeno-na-aspeesticon',
    ZaplacenaPodpora: 'zaplacena-podpora',
    Zapujcka: 'zapujcka',
    NeniOdpoved: 'neni-odpoved',
    PrevedenoNaAspeesticonHyperon: 'prevedeno-na-aspeesticon-hyperon',
    TrezorZaplacena: 'trezor-zaplacena',
    VypovezenaZaplacena: 'vypovezena-zaplacena',
    VypovezenaNezaplacena: 'vypovezena-nezaplacena',
    VypovezenaPodpora: 'vypovezena-podpora',
    NezaplacenaPodpora: 'nezaplacena-podpora',
    Pronajem: 'pronajem',
    IndividualniSmlouva: 'individualni-smlouva',
    ObchodniPartner: 'obchodni-partner',
    PrevedeneLicence: 'prevedene-licence',
    InterniSubjekt: 'interni-subjekt'
} as const;
export type PaymentStateEnum = typeof PaymentStateEnum[keyof typeof PaymentStateEnum];


export function instanceOfPaymentStateEnum(value: any): boolean {
    for (const key in PaymentStateEnum) {
        if (Object.prototype.hasOwnProperty.call(PaymentStateEnum, key)) {
            if (PaymentStateEnum[key as keyof typeof PaymentStateEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentStateEnumFromJSON(json: any): PaymentStateEnum {
    return PaymentStateEnumFromJSONTyped(json, false);
}

export function PaymentStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStateEnum {
    return json as PaymentStateEnum;
}

export function PaymentStateEnumToJSON(value?: PaymentStateEnum | null): any {
    return value as any;
}

export function PaymentStateEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentStateEnum {
    return value as PaymentStateEnum;
}

